module.exports = __webpack_public_path__ + "static/img/zidongjieting.dae1e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zidongjieting.png
// module id = ukQu
// module chunks = 24